import { render, staticRenderFns } from "./FlightListLoading.vue?vue&type=template&id=72b95e8d&scoped=true&"
import script from "./FlightListLoading.vue?vue&type=script&lang=js&"
export * from "./FlightListLoading.vue?vue&type=script&lang=js&"
import style0 from "./FlightListLoading.vue?vue&type=style&index=0&id=72b95e8d&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b95e8d",
  null
  
)

export default component.exports